import { useSnapshot } from "valtio";
import uiState from "../data";
import { motion, AnimatePresence } from "framer-motion";
import { windowSizeState } from "../utils/windowSize";
import { googleSheet } from "../utils/getSheet";

const FactoryEntrance = ({ event }) => {
  const { visible } = useSnapshot(uiState[event]);
  const { mobileMode } = useSnapshot(windowSizeState);
  const { isMusicPlay } = useSnapshot(uiState.bgm);
  const data = googleSheet["homepage"].filter((el) => {
    return el.part === "factory_entrance";
  })[0];
  const hideAllInstrumentIframes = () => {
    uiState.trumpetIframe.visible = false;
    uiState.saxIframe.visible = false;
    uiState.frenchhornIframe.visible = false;
    uiState.tromboneIframe.visible = false;
    uiState.susIframe.visible = false;
  };

  // GA
  function gtag() {
    // Ensure GA dataLayer exists (prevents click handlers from crashing)
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  // const goTrumpet = () => {
  //   gtag("event", `homepage factory entrance:select trumpet`);

  //   let bgm = document.getElementById("bgm");
  //   let trumpetIframe = document.getElementById("trumpetIframe");

  //   uiState.bgm.bgmSrc = "../startImages/music/trumpet.mp3";
  //   uiState.trumpetIframe.visible = true;
  //   sessionStorage.setItem("activeWeb", "trumpet");

  //   if (sessionStorage.getItem("introState") !== "close") {
  //     sessionStorage.setItem("introState", "init");
  //   } else {
  //     if (isMusicPlay && bgm) {
  //       bgm.currentTime = 0;
  //       setTimeout(() => {
  //         trumpetIframe.contentWindow.uiState.bgm.isMusicPlay = true;
  //         bgm.play();
  //       }, 1200);
  //     } else {
  //       trumpetIframe.contentWindow.uiState.bgm.isMusicPlay = false;
  //     }
  //   }
  // };

  const goTrumpet = () => {
    gtag("event", `homepage factory entrance:select trumpet`);

    const bgm = document.getElementById("bgm");

    hideAllInstrumentIframes();
    uiState.bgm.bgmSrc = "../startImages/music/trumpet.mp3";
    uiState.trumpetIframe.visible = true;
    sessionStorage.setItem("activeWeb", "trumpet");

    if (sessionStorage.getItem("introState") !== "close") {
      sessionStorage.setItem("introState", "init");
    } else {
      const trumpetIframe = document.getElementById("trumpetIframe");
      if (!trumpetIframe) return;
      trumpetIframe.onload = () => {
        try {
          const innerBgm = trumpetIframe?.contentWindow?.uiState?.bgm;
          if (!innerBgm) return;
          if (isMusicPlay && bgm) {
            bgm.currentTime = 0;
            innerBgm.isMusicPlay = true;
            bgm.play();
          } else {
            innerBgm.isMusicPlay = false;
          }
        } catch (e) {
          console.error("iframe communication error", e);
        }
      };
    }
  };

  const goSax = () => {
    gtag("event", `homepage factory entrance:select sax`);

    let bgm = document.getElementById("bgm");
    hideAllInstrumentIframes();
    uiState.bgm.bgmSrc = "../startImages/music/sax.mp3";
    uiState.saxIframe.visible = true;
    sessionStorage.setItem("activeWeb", "sax");

    if (sessionStorage.getItem("introState") !== "close") {
      sessionStorage.setItem("introState", "init");
    } else {
      const saxIframe = document.getElementById("saxIframe");
      const innerBgm = saxIframe?.contentWindow?.uiState?.bgm;
      if (!innerBgm) return;

      if (isMusicPlay && bgm) {
        bgm.currentTime = 0;
        setTimeout(() => {
          try {
            innerBgm.isMusicPlay = true;
            bgm.play();
          } catch (e) {
            console.error("iframe communication error", e);
          }
        }, 1200);
      } else {
        innerBgm.isMusicPlay = false;
      }
    }
  };

  const goFrenchhorn = () => {
    gtag("event", `homepage factory entrance:select frenchhorn`);

    let bgm = document.getElementById("bgm");
    hideAllInstrumentIframes();
    uiState.bgm.bgmSrc = "../startImages/music/hn.mp3";
    uiState.frenchhornIframe.visible = true;
    sessionStorage.setItem("activeWeb", "frenchhorn");

    if (sessionStorage.getItem("introState") !== "close") {
      sessionStorage.setItem("introState", "init");
    } else {
      const frenchhornIframe = document.getElementById("frenchhornIframe");
      const innerBgm = frenchhornIframe?.contentWindow?.uiState?.bgm;
      if (!innerBgm) return;

      if (isMusicPlay && bgm) {
        bgm.currentTime = 0;
        setTimeout(() => {
          try {
            innerBgm.isMusicPlay = true;
            bgm.play();
          } catch (e) {
            console.error("iframe communication error", e);
          }
        }, 1200);
      } else {
        innerBgm.isMusicPlay = false;
      }
    }
  };

  const goTrombone = () => {
    gtag("event", `homepage factory entrance:select trombone`);

    let bgm = document.getElementById("bgm");
    hideAllInstrumentIframes();
    uiState.bgm.bgmSrc = "../startImages/music/tb.mp3";
    uiState.tromboneIframe.visible = true;
    sessionStorage.setItem("activeWeb", "trombone");

    if (sessionStorage.getItem("introState") !== "close") {
      sessionStorage.setItem("introState", "init");
    } else {
      const tromboneIframe = document.getElementById("tromboneIframe");
      const innerBgm = tromboneIframe?.contentWindow?.uiState?.bgm;
      if (!innerBgm) return;

      if (isMusicPlay && bgm) {
        bgm.currentTime = 0;
        setTimeout(() => {
          try {
            innerBgm.isMusicPlay = true;
            bgm.play();
          } catch (e) {
            console.error("iframe communication error", e);
          }
        }, 1200);
      } else {
        innerBgm.isMusicPlay = false;
      }
    }
  };

  // 更新寫法test
  // const goInstrumentHandler = ({
  //   name, // 樂器英文名稱，如 "trumpet"
  //   iframeId, // iframe 的 DOM ID
  //   musicPath, // 音樂檔路徑
  //   delayPlay = 0, // 音樂延遲播放（毫秒）
  // }) => {
  //   gtag("event", `homepage factory entrance:select ${name}`);

  //   const bgm = document.getElementById("bgm");
  //   const iframe = document.getElementById(iframeId);

  //   if (!iframe) return;

  //   uiState.bgm.bgmSrc = musicPath;
  //   uiState[`${name}Iframe`].visible = true;
  //   sessionStorage.setItem("activeWeb", name);

  //   if (sessionStorage.getItem("introState") !== "close") {
  //     sessionStorage.setItem("introState", "init");
  //   } else {
  //     const playMusic = () => {
  //       try {
  //         if (isMusicPlay && bgm) {
  //           bgm.currentTime = 0;
  //           iframe.contentWindow.uiState.bgm.isMusicPlay = true;
  //           bgm.play();
  //         } else {
  //           iframe.contentWindow.uiState.bgm.isMusicPlay = false;
  //         }
  //       } catch (e) {
  //         console.error("iframe communication error", e);
  //       }
  //     };

  //     if (delayPlay > 0) {
  //       setTimeout(playMusic, delayPlay);
  //     } else {
  //       iframe.onload = playMusic;
  //     }
  //   }
  // };

  // const goTrumpet = () =>
  //   goInstrumentHandler({
  //     name: "trumpet",
  //     iframeId: "trumpetIframe",
  //     musicPath: "../startImages/music/trumpet.mp3",
  //   });

  // const goSax = () =>
  //   goInstrumentHandler({
  //     name: "sax",
  //     iframeId: "saxIframe",
  //     musicPath: "../startImages/music/sax.mp3",
  //     delayPlay: 1200,
  //   });

  // const goFrenchhorn = () =>
  //   goInstrumentHandler({
  //     name: "frenchhorn",
  //     iframeId: "frenchhornIframe",
  //     musicPath: "../startImages/music/hn.mp3",
  //     delayPlay: 1200,
  //   });

  // const goTrombone = () =>
  //   goInstrumentHandler({
  //     name: "trombone",
  //     iframeId: "tromboneIframe",
  //     musicPath: "../startImages/music/tb.mp3",
  //     delayPlay: 1200,
  //   });

  const goEnterPage = () => {
    hideAllInstrumentIframes();
    uiState.enterPage.visible = true;
    uiState[event].visible = false;
  };

  return (
    <>
      {visible && (
        <div className="fixed top-0 left-0 screen-setting overflow-hidden factory-bg pointer-events-none z-40">
          <img
            src="../startImages/bg/factory_choosepano_BG.jpg"
            alt="背景圖"
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            className="screen-setting overflow-hidden fixed top-0 left-0 z-50 "
          >
            <img
              src="../startImages/bg/factory_choosepano_BG.jpg"
              alt="背景圖"
              className="w-full h-full object-cover"
            />
            <div className="absolute top-0 left-0  w-full h-full bg-black/30 pointer-events-none"></div>
            <img
              src="../startImages/icon/back_w.png"
              alt="返回鍵"
              className={`absolute top-[80px]  left-[164px]  portraitPad:left-[8%] portraitPad:top-[70px] smallLaptop:left-[8%] landscapePad:left-[8%] authPCHeight:left-[10%]  w-[130px] portraitPh:w-[78px] portraitPh:top-[50px] landscapePhone:w-[78px] landscapePhone:top-[50px] landscapePhone:left-[10%] cursor-pointer ${
                !mobileMode && "opacity-70"
              } hover:opacity-100 `}
              onClick={goEnterPage}
            />
            <img
              src="../startImages/bg/factory_choosepano_BG.jpg"
              alt="背景"
              className=" w-full h-full object-cover  "
            />
            <img
              src="../startImages/line/stroke.png"
              alt="logo旁邊的線"
              className="  absolute top-[20px] left-1/2 -translate-x-1/2 w-[95%] z-10"
            />
            <img
              src="../startImages/logo/logo_w.png"
              alt="logo"
              className=" absolute top-0 left-1/2 -translate-x-1/2 w-[100px] z-10 portraitBigPh:w-[80px] landscapePhone:w-[80px]"
            />
            <div className=" absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2  flex flex-col items-center h-[33%] portraitPad:h-[40%] justify-between w-[60%] smallLaptop:h-[40%] portraitPad:w-[85%] landscapePhone:w-[50%] ">
              <div>
                <img
                  src={
                    mobileMode
                      ? "../startImages/text/factory_choosepano_MB_Text.png"
                      : "../startImages/text/factory_choosepano_text_pc.png"
                  }
                  alt="陰影版文字"
                  className=" landscapePhone:mb-4 "
                />
              </div>
              {/* 原本僅有內層flex */}
              <div className="flex overflow-x-auto overflow-y-hidden touch-pan-x portraitPhone:w-full">
                <div className="flex gap-[30px] px-2 portraitBigPh:gap-[5px]">
                  <img
                    src={
                      mobileMode
                        ? "../startImages/icon/TRU_Pano_MB.png"
                        : "../startImages/icon/TRU_Pano.png"
                    }
                    alt="前往小號環景"
                    className="w-[160px] mr-[50px] portraitBigPh:mr-[0px] object-contain cursor-pointer hover:scale-[1.05] portraitBigPh:w-[140px] landscapePhone:w-[120px]"
                    onClick={goTrumpet}
                  />
                  <img
                    src={
                      mobileMode
                        ? "../startImages/icon/SAX_Pano_MB.png"
                        : "../startImages/icon/SAX_Pano.png"
                    }
                    alt="前往薩克斯風環景"
                    className="w-[160px] mr-[50px] object-contain portraitBigPh:mr-[10px] cursor-pointer hover:scale-[1.05] portraitBigPh:w-[140px] landscapePhone:w-[120px]"
                    onClick={goSax}
                  />
                  <img
                    src={
                      mobileMode
                        ? "../startImages/icon/TRO_Pano_MB.png"
                        : "../startImages/icon/TRO_Pano.png"
                    }
                    alt="前往長號環景"
                    className="w-[160px] mr-[50px] object-contain portraitBigPh:mr-[10px] cursor-pointer hover:scale-[1.05] portraitBigPh:w-[140px] landscapePhone:w-[120px]"
                    onClick={goTrombone}
                  />
                  <img
                    src={
                      mobileMode
                        ? "../startImages/icon/FRE_Pano_MB.png"
                        : "../startImages/icon/FRE_Pano.png"
                    }
                    alt="前往法國號環景"
                    className="w-[160px]  object-contain  cursor-pointer hover:scale-[1.05] portraitBigPh:w-[140px] landscapePhone:w-[120px]"
                    onClick={goFrenchhorn}
                  />
                </div>
              </div>
            </div>
            <div className=" absolute bottom-[30px] left-[50px] text-[22px] Trajan text-white portraitBigPh:text-[16px] portraitBigPh:left-[16px] portraitBigPh:bottom-[12px] landscapePhone:left-[16px] landscapePhone:text-[16px] landscapePhone:bottom-[12px]">
              {data.en_btn1}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FactoryEntrance;
